<template>
  <div :class="[
         'scrollable',
         $style.scrollable
       ]"
       @scroll="$emit('scroll', $event)"
  >
    <slot/>
  </div>
</template>

<script>
/*
 *
 * b-scrollable component
 *
 */
export default {

  emits: [
    'scroll',
  ],
  name: 'b-scrollable',
}
</script>

<style lang="scss" module>
@layer legacy-views {

.scrollable {
  overflow: auto;
}

}</style>
